import { render, staticRenderFns } from "./BrickBase.vue?vue&type=template&id=f4f9744c&"
import script from "./BrickBase.vue?vue&type=script&lang=js&"
export * from "./BrickBase.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("Q:\\Projects\\dnx-dpn\\MarketingDb.Web\\node_modules\\vue-hot-reload-api\\dist\\index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('f4f9744c')) {
      api.createRecord('f4f9744c', component.options)
    } else {
      api.reload('f4f9744c', component.options)
    }
    module.hot.accept("./BrickBase.vue?vue&type=template&id=f4f9744c&", function () {
      api.rerender('f4f9744c', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "ScriptsV2/Core/Modules/JourneyBuilder/Components/Patterns/BrickBase.vue"
export default component.exports